import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService, DropdownPicklistComponent, InputComponent } from 'yt-ng-framework';
import { KomitentVozilo } from './komitent-vozilo';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Komitent } from '../komitent/komitent';
import { List } from 'immutable';
import { KomitentView } from '../komitent/komitent-view';

@Component({
  selector: 'yt-komitent-vozilo-update',
  templateUrl: './komitent-vozilo-update.component.html'
})
export class KomitentVoziloUpdateComponent
  extends BaseUpdateComponent<KomitentVozilo>
  implements OnInit {

  parameterList: List<QueryParameter> = List([]);
  KomitentIDParam: QueryParameter = new QueryParameter();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  @ViewChild('cmbKomitent', { static: true }) cmbKomitent : DropdownPicklistComponent<KomitentView>;
    @ViewChild('txtRgBr', { static: true }) txtRgBr : InputComponent;

  ngOnInit() {
    // inicijalni QueryParameter za komitenta
    this.KomitentIDParam.Name = "komitentid";
    this.KomitentIDParam.Value = -1;
    this.parameterList = this.parameterList.push(this.KomitentIDParam);

    // Validacije
    this.addValidatorToFc("KomitentID", Validators.required, "required", "KOMITENTVOZILO.KOMITENT.VALIDATION.REQUIRED");
    this.addValidatorToFc("RgBr", Validators.required, "required", "KOMITENTVOZILO.RGBR.VALIDATION.REQUIRED");
    this.addValidatorToFc("RgBr", Validators.maxLength(20), "maxlength", "KOMITENTVOZILO.RGBR.VALIDATION.MAXLENGTH");

    // Kada se form učita i obradi ID (npr. kod editovanja)
    this.IDProcessed
      .subscribe((value) => {
        if (value) {
          const komitentIDValue = this.baseFormGroup.get('KomitentID')?.value;
          if (komitentIDValue != null) {
            this.KomitentIDParam.Value = komitentIDValue;
            this.KomitentIDParam.Name = "komitentid";
            this.parameterList = List([this.KomitentIDParam]);
          }
        }
      });
  }

  pamtiVrednostKomitentID: number;

  onKomitentSelect(value: Komitent) {
    if (value) {
      if (this.pamtiVrednostKomitentID && this.pamtiVrednostKomitentID !== value.ID) {
        this.baseFormGroup.patchValue({ KomitentID: value.ID });
        this.baseFormGroup.get("KomitentID")?.updateValueAndValidity();
      }

      this.parameterList = List([]);
      this.KomitentIDParam.Name = "komitentid";
      this.KomitentIDParam.Value = value.ID;
      this.parameterList = this.parameterList.push(this.KomitentIDParam);
      this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
      this.pamtiVrednostKomitentID = value.ID;
    }
  }

  ngAfterViewInit() {
    if (this.ParentProperty.Value) {
      setTimeout(() => {
        this.baseFormGroup.patchValue({ KomitentID: this.ParentProperty.Value});
        this.baseFormGroup.get("KomitentID").disable();  
        this.txtRgBr.focus();  
      },0)
    }
      else
          this.cmbKomitent.focus();
  }

}
